'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
var fontIcon = require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
var standardTextfield = require('../standard-textfield/standard-textfield.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/**
 * A convenience component for showing a search input with icon.
 *
 * The wrapping `<form>` element should have `role="search"`.
 *
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/search
 *
 * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/search_role
 *
 * @param props SearchTextfieldProps
 * @returns FunctionComponent<SearchTextfieldProps>
 */ const SearchTextfield = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    return /*#__PURE__*/ React__default.default.createElement(standardTextfield.StandardTextfield, _extends({}, props, {
        className: classnames__default.default({
            'bf-textfield__search': true,
            [`${props?.className}`]: !!props?.className
        }),
        leftIcon: fontIcon.FontIcons.Search,
        ref: ref,
        type: "search"
    }));
});

exports.SearchTextfield = SearchTextfield;
//# sourceMappingURL=search-textfield.js.map
